import {
  PushEvent,
  isAccountBalanceChangedExceptionPushEvent,
  isAccountBalanceChangedPushEvent,
  isPayIdStatusChangedPushEvent,
  isWithdrawChannelChangedPushEvent,
} from '@rwwa/tabtouch-push-contract'
import { QueryClient } from '@tanstack/react-query'
import { FeedbackPayIdStatusChange } from '../Areas/Deposit/Utils/FeedbackPayIdStatusChange'
import { FeedbackWithdrawalChannelChange } from '../Areas/Withdraw/Utils/FeedbackWithdrawalChannelChange'
import { FeedbackBalanceChange } from './FeedbackBalanceChange'
import { queryKeys } from './constants'

export const balanceUpdate = (
  payload: PushEvent,
  queryClient: QueryClient,
  onSuccess: () => void
) => {
  const isBalanceChangedSuccess = isAccountBalanceChangedPushEvent(payload)
  const isBalanceChangedError = isAccountBalanceChangedExceptionPushEvent(payload)
  if (!isBalanceChangedSuccess && !isBalanceChangedError) return

  FeedbackBalanceChange(payload)
  if (isBalanceChangedSuccess) {
    onSuccess()
    queryClient.invalidateQueries({
      queryKey: queryKeys.depositInitialData,
    })
    queryClient.invalidateQueries({
      queryKey: queryKeys.withdrawDetails,
    })
    queryClient.invalidateQueries({
      queryKey: queryKeys.betAccount,
    })
  }
}

export const payIdUpdate = (
  payload: PushEvent,
  accountNumber: number,
  queryClient: QueryClient
) => {
  if (isPayIdStatusChangedPushEvent(payload)) {
    FeedbackPayIdStatusChange(accountNumber, payload.status)
    // Refetch the PayId details
    queryClient.invalidateQueries({
      queryKey: queryKeys.betAccount,
    })
  }
}

export const withdrawChannelUpdate = (payload: PushEvent) => {
  if (isWithdrawChannelChangedPushEvent(payload)) {
    FeedbackWithdrawalChannelChange()
  }
}
